// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"704c45a5fccd76ca0532","655":"c79615f54634090e5e4e"}[chunkId] + ".js";
};